const setupE2Image = () => {
  // Override image so we can catch moat pixel fires
  if (typeof Proxy === 'function') {
    console.log('Adding Proxy for HTMLImageElement');
    /*
     * Extend native Image function to capture src urls.
     * Capture last MOAT pixel url for logging.
     */
    const E2Image = Image;
    class E2ImageClass {
      constructor(w, h) {
        const e2Image = new E2Image(w, h);
        const moatpixel = function moatpixel(value) {
          return (
            typeof value === 'string' && value.indexOf('moat') > -1 && value.indexOf('pixel.gif') > -1
          );
        };
        const handler = {
          set(obj, prop, value) {
            if (prop === 'src' && moatpixel(value)) {
              window.top.postMessage(
                JSON.stringify({
                  action: 'moat_pixel_update',
                  m2m_impr_id: 0,
                  moatPixel: value,
                }),
                '*'
              );
            }
            return (e2Image[prop] = value);
          },
        };
        const prox = new Proxy(e2Image, handler);
        try {
          prox[Symbol.toStringTag] = 'HTMLImageElement';
        } catch (e) {}
        return prox;
      }
    }
    // eslint-disable-next-line
    Image = E2ImageClass;
  }
};

export { setupE2Image };
